import React from 'react';
import { useDevice } from '../../infrastructure/hooks/useDevice';

type Props = { children?: React.ReactNode };

export const DesktopOnly = ({ children }: Props) => {
  const { isDesktop } = useDevice();

  if (!isDesktop) {
    return null;
  }

  return <>{children}</>;
};
